module.exports = __webpack_public_path__ + "img/rank-logo-hover.10c4ea56.png";